<template>
  <div class="big-event box">
    <div class="container">

      <!-- 标题 -->
      <div class="home-title">
        <h1>大事件</h1>
         <h3>
          <a href="https://www.infoq.cn/profile/8E5635FB78E196/publish" target="_blank">查看更多></a>
        </h3>
      </div>

      <!-- 内容 -->
      <div class="event-content">
        <div class="event-wrapper-mobile"><NewsColumn :data="events[0]" :config="{ hasSummary: false }" /></div>
        <div class="event-wrapper-mobile"><NewsColumn :data="events[1]" :config="{ hasSummary: false }" /></div>
        <div class="event-wrapper-mobile"><NewsColumn :data="events[2]" :config="{ hasSummary: false }" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsColumn from '@/components/columns/News'

export default {
  props: ['events'],
  components: {
    NewsColumn
  }
}
</script>

<style lang="scss" scoped>
@import '~@/style/variable.sass';
$gap: 16px;

// .column {
//   padding: $gap /2;
// }

.big-event {
  // padding-top: 40px;
  // background-color: #f5f5f5;
}
.home-title {
  margin-bottom: 20px;
}

// 内容部分
.event-content {
  .event-wrapper-mobile {
    width: 100%;
    padding-bottom: 47%;
    position: relative;
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

</style>
